import { Text } from '@mantine/core';
import { Handle, Position } from 'reactflow';
import { Show } from '../../../../../../react-commons/components/control-flow/Show';
import {
    getVersionGraphNodeBorder,
    getVersionGraphNodeColor,
    VersionGraphNodeData,
} from './VariantedVersionGraphNodeType';

export const versionGraphNodeWidth = 180;
export const versionGraphNodeHeight = 60;

export const VersionGraphNodeType= ({ data, selected }: {
    data: VersionGraphNodeData;
    selected: boolean;
}) => {
    const versionStateLabel = data.versionState;

    return (
        <>
            <Handle
                type="source"
                position={Position.Top}
                id={`${data.id}-top`}
                isConnectable={false}
                style={{ opacity: data.hasChild ? 1 : 0 }}
            />
            <div
                className="selectable-node nowheel nodrag"
                style={{
                    width: versionGraphNodeWidth,
                    height: versionGraphNodeHeight,
                    background: getVersionGraphNodeColor(data.isActive),
                    border: getVersionGraphNodeBorder(selected),
                    borderRadius: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: 'large',
                    cursor: 'pointer',
                }}
            >
                <Show when={!data.label}>
                    {data.versionNumber}
                    <br />
                    {versionStateLabel}
                </Show>
                <Show when={data.label}>
                    <Text truncate={'end'}>{data.label}</Text>
                </Show>
            </div>
            <Handle
                type="target"
                position={Position.Bottom}
                id={`${data.id}-bottom`}
                isConnectable={false}
                style={{ opacity: data.hasParent ? 1 : 0 }}
            />
        </>
    );
};
